/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentAvailableContactSlot from './AgentAvailableContactSlot';

/**
 * The AgentAvailableContactSlotsResponse model module.
 * @module model/AgentAvailableContactSlotsResponse
 * @version 1.0.0
 */
class AgentAvailableContactSlotsResponse {
    /**
     * Constructs a new <code>AgentAvailableContactSlotsResponse</code>.
     * @alias module:model/AgentAvailableContactSlotsResponse
     * @param availableContactSlots {Array.<module:model/AgentAvailableContactSlot>} 連絡対応可能枠。空配列は「全枠対応可（未設定）」
     */
    constructor(availableContactSlots) { 
        
        AgentAvailableContactSlotsResponse.initialize(this, availableContactSlots);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, availableContactSlots) { 
        obj['available_contact_slots'] = availableContactSlots;
    }

    /**
     * Constructs a <code>AgentAvailableContactSlotsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentAvailableContactSlotsResponse} obj Optional instance to populate.
     * @return {module:model/AgentAvailableContactSlotsResponse} The populated <code>AgentAvailableContactSlotsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentAvailableContactSlotsResponse();

            if (data.hasOwnProperty('available_contact_slots')) {
                obj['available_contact_slots'] = ApiClient.convertToType(data['available_contact_slots'], [AgentAvailableContactSlot]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentAvailableContactSlotsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentAvailableContactSlotsResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentAvailableContactSlotsResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['available_contact_slots']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['available_contact_slots'])) {
                throw new Error("Expected the field `available_contact_slots` to be an array in the JSON data but got " + data['available_contact_slots']);
            }
            // validate the optional field `available_contact_slots` (array)
            for (const item of data['available_contact_slots']) {
                AgentAvailableContactSlot.validateJSON(item);
            };
        }

        return true;
    }


}

AgentAvailableContactSlotsResponse.RequiredProperties = ["available_contact_slots"];

/**
 * 連絡対応可能枠。空配列は「全枠対応可（未設定）」
 * @member {Array.<module:model/AgentAvailableContactSlot>} available_contact_slots
 */
AgentAvailableContactSlotsResponse.prototype['available_contact_slots'] = undefined;






export default AgentAvailableContactSlotsResponse;

